import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const benefits = [{
  title: 'Saber EXACTAMENTE qué hacer si olvidas una pastilla',
  desc: 'Sin pánico, sin Google, con la respuesta correcta'
}, {
  title: 'Entender cómo funciona tu píldora dentro de tu cuerpo',
  desc: 'Porque cuando entiendes algo, lo haces mejor'
}, {
  title: 'Distinguir un efecto secundario normal de uno peligroso',
  desc: 'Y saber cuándo ir al médico vs cuándo esperar'
}, {
  title: 'Tomar tu pastilla con un sistema que crea el hábito',
  desc: 'Con alarmas, anclas y checklists que funcionan'
}, {
  title: 'Conocer los beneficios extra que probablemente no sabías',
  desc: 'Acné, SOP, cólicos, endometriosis y más'
}, {
  title: 'Tener una referencia rápida siempre a la mano',
  desc: 'La tarjeta de emergencia que va contigo a todas partes'
}, {
  title: 'Hacer seguimiento de síntomas por 6 meses',
  desc: 'Para hablar con tu médico con datos reales'
}, {
  title: 'Sentirte segura y empoderada con tu método',
  desc: 'Porque la información correcta da tranquilidad'
}];
export function Benefits() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-17">
      <div className="text-center mb-16" data-id="element-18">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-dark" data-id="element-19">
          Después de leer esta guía vas a poder...
        </h2>
      </div>

      <div className="space-y-6 mb-16" data-id="element-20">
        {benefits.map((benefit, index) => <motion.div key={index} initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="flex items-start gap-4 bg-white p-6 rounded-[16px] shadow-sm border border-brand-cardPurple/30" data-id="element-21">
            <div className="bg-brand-success/10 p-2 rounded-full shrink-0" data-id="element-22">
              <Check className="w-6 h-6 text-brand-success" data-id="element-23" />
            </div>
            <div data-id="element-24">
              <h3 className="text-lg font-bold text-brand-dark mb-1" data-id="element-25">
                {benefit.title}
              </h3>
              <p className="text-brand-secondary" data-id="element-26">→ {benefit.desc}</p>
            </div>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="bg-gradient-primary rounded-[16px] p-8 md:p-12 text-center text-white shadow-xl" data-id="element-27">
        <p className="text-xl md:text-2xl font-heading font-bold leading-relaxed" data-id="element-28">
          "No más búsquedas de emergencia a las 2am.
          <br data-id="element-29" />
          No más confusión. No más miedo.
          <br data-id="element-30" />
          Solo claridad, seguridad y control. 💜"
        </p>
      </motion.div>
    </section>;
}